import React from 'react';
import { useContext } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { SubmitSearchButtonId } from '../../utils/SearchPanelConst';
import { AppContext } from '../../context/AppContext';
import classNames from 'classnames';

import './BuildingType.css';

const BuildingType: React.VFC = () => {
  const [ t ] = useTranslation();
  const { register } = useFormContext();
  const { searchCond } = useContext(AppContext);

  const handleChange = () => {
    // タイプ変更時に再検索させる。
    const submit_search_button = document.getElementById(SubmitSearchButtonId);
    if (!submit_search_button) return;
    submit_search_button.click();
  }

  return (
    <div id="BuildingType">
      <div className="searchgroup">
        <div className="building_type_box">
          <div className="col">
            <div className={classNames('building_type_common', 'building_type1')}><input type="checkbox" value="1" defaultChecked={searchCond['building_type1'] === '1'} {...register('building_type1', { onChange: handleChange })}></input><label htmlFor="building_type1">{t('オフィス')}</label></div>
            <div className={classNames('building_type_common', 'building_type2')}><input type="checkbox" value="2" defaultChecked={searchCond['building_type2'] === '2'} {...register('building_type2', { onChange: handleChange })}></input><label htmlFor="building_type2">{t('レジデンシャル')}</label></div>
            <div className={classNames('building_type_common', 'building_type3')}><input type="checkbox" value="3" defaultChecked={searchCond['building_type3'] === '3'} {...register('building_type3', { onChange: handleChange })}></input><label htmlFor="building_type3">{t('リテール')}</label></div>
          </div>
          <div className="col">
            <div className={classNames('building_type_common', 'building_type4')}><input type="checkbox" value="4" defaultChecked={searchCond['building_type4'] === '4'} {...register('building_type4', { onChange: handleChange })}></input><label htmlFor="building_type4">{t('ロジスティクス')}</label></div>
            <div className={classNames('building_type_common', 'building_type5')}><input type="checkbox" value="5" defaultChecked={searchCond['building_type5'] === '5'} {...register('building_type5', { onChange: handleChange })}></input><label htmlFor="building_type5">{t('ホテル')}</label></div>
            <div className={classNames('building_type_common', 'building_type6')}><input type="checkbox" value="99" defaultChecked={searchCond['building_type99'] === '99'} {...register('building_type99', { onChange: handleChange })}></input><label htmlFor="building_type99">{t('その他')}</label></div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BuildingType;
